<template>
  <base-layout :page-title=chatpage_title>
    <template v-slot:actions-end v-if="session?.user">
      <ion-button router-link="/review" v-if="debug">
        <ion-icon slot="icon-only" :icon="chevronBackCircle"></ion-icon>
      </ion-button>
    </template>

    <div v-if="isLoading">
      <LoadingScreen></LoadingScreen>
    </div>
    <div v-else>
      <!-- Only show login card if session is truly missing after getProfile finishes -->
      <div v-if="!session?.user" class="ion-padding ion-text-center">
        <ion-card style="margin-top: 4rem;">
          <ion-card-header>
            <ion-card-title>{{ t('login_required_title') || 'Giraffe needs you to sign in' }}</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <p>{{ t('login_required_msg') || 'To continue with your personal AI support, please sign in first.' }}</p>
            <ion-button expand="block" shape="round" router-link="/" class="ion-margin-top">
              {{ t('go_to_login') || 'Go to Login' }}
            </ion-button>
          </ion-card-content>
        </ion-card>
      </div>
      <div v-else>
        <div id='div_greeting' v-if="r_show_greeting">
          <div v-if="!r_show_charge_info && !r_show_chat_start">
            <div v-if="!new_user">
              <ChatMessage class='hidden'>{{ user_alias }}，{{t('chat_see_you_again')}}</ChatMessage>
            </div>
            <div v-else id='div_first_time'>
              <div id="div_ask_alias">
                <div><img src="/assets/whats_your_name.png"></div> 
                <ChatInputArea v-model="user_alias" :placeholder="name_prompt" @click_submit="submit_my_username()">
                </ChatInputArea>
                <ChatMessage>{{ t('chat_reminder') }}<br />
                  {{ t('chat_open') }}<br />
                  {{ t('chat_confidential1') }}<br />
                </ChatMessage>
              </div>
            </div>
          </div>
          <div v-if="r_show_charge_info" id='div_charge_info'>
            <ChatMessage v-if='!new_user' class='hidden'>{{t('chat_if_suicide_thought')}}
              <router-link :to="{name:'HotLine'}">{{t('chat_click_here')}}</router-link>
            
            </ChatMessage>
            <ChatMessage v-if="!new_user">{{ t('chat_reminder') }}<br />
              {{ t('chat_open') }}<br />
              {{ t('chat_confidential1') }}<br />
            </ChatMessage>
            <ChatMessage v-if='session?.user?.need_money && session?.user?.need_money>0'>
              {{ t('insufficient_antlers_prefix') }}
              <router-link :to="{path:'/recharge'}">
                <b>{{ t('recharge_amount', { amount: windowLanguage === 'zh' ? Math.ceil(session.user.need_money) : session.user.need_money.toFixed(1) }) }}</b>
              </router-link>
              {{ t('insufficient_antlers_suffix') }}
            </ChatMessage>
            <div class="center hidden" v-if="!new_user">
              <!-- Re-check if they have enough balance when they click OK (e.g., they recharged in another tab). Otherwise, force them to recharge link. -->
              <ion-button v-if="amount >= amount_per_chat" shape="round" @click="chat_greeting" class="navBtn">OK</ion-button>
            </div>
          </div>
          <div v-if="r_show_chat_start" id="div_chat_start" class="start-session-container">
            <ChatMessage>{{t('chat_method_scope')}}</ChatMessage>
            <ChatMessage>{{t('chat_confidential')}}</ChatMessage>
            <ChatMessage>{{t('chat_time_scale')}}</ChatMessage>
            <ChatMessage>{{t('chat_quiet_space')}}</ChatMessage>
            <div class="center-btn-wrapper">
              <ion-button shape="round" @click="start_chat_ai" class="navBtn">{{t('chat_click_start')}}</ion-button>
            </div>
          </div>
        </div>

        <Transition>
          <div v-if="r_show_shudong">
            <div id="messagesWrapper">
              <ChatMessage>{{t('chat_voice0')}}<br/>
                {{t('chat_voice1a')}}<ion-icon :icon="micOutline"/>{{t('chat_voice1b')}}<br/>
                {{t('chat_voice2a')}}<ion-icon :icon="micOutline"/>{{t('chat_voice2b')}}<br/>
                {{t('chat_voice3a')}}<ion-icon :icon="micOutline"/>{{t('chat_voice3b')}}
              </ChatMessage>
              <ChatMessage v-for="(message, i) in chat_messages" :key="i" class="chat-message" :fromUser="i % 2 == 1">
                <!-- even from AI, odd: from user -->
                <div v-if="i % 2 == 0 && isDictionary(message) && message.type=='list'">
                  <div>
                    {{ message.isInitialTitle ? message.title : message.title_update }}
                  </div>
                  <ion-list v-if="message.choicesVisible">
                    <ion-item v-for="(choice, index) in message.choices" :key="index" :disabled="allButtonsDisabled">
                      <ion-button v-if="visibleButtons.includes(index)" size="large" fill="outline" expand="block"
                        @click="userSelectChoiceFromAI(choice, index, i)">
                        {{
                          choice }}</ion-button>
                    </ion-item>
                  </ion-list>
                </div>
                 <div v-else-if="i % 2 == 0 && isDictionary(message) && message.type=='meditation'">
                  <img id="body_ex_bg" src="/assets/icon/meditation.gif">
                  <audio id="body_ex_au" src="/assets/audio/bodyExEllen.mp3" controls></audio>
                </div>             
                <div v-else>
                  {{ message }}
                </div>
              </ChatMessage>
            </div>
            <div id="div_details" class="bottom-input"> 
              <ion-button v-if="g_user_chat_history.user_input && !disableInput && g_user_chat_history.user_input.length > 100" fill="clear" style="margin-bottom: 10px; font-size: 12px; text-transform: none;"
                            @click="ai_more_details(1)">  <!-- 如果用户点击结束板块，则end=1，跳到感受 -->
                  <ion-icon :icon="chevronForwardCircle"/>
                  {{ ai_detail_no }}
              </ion-button> 
              <ChatInputArea v-model="r_user_input" :placeholder="input_prompt" :disabled='disableInput'
                 @click_submit="submit_user_input()"></ChatInputArea> <!-- 对话，回应 -->
            </div>
          </div>
        </Transition>


      </div>
    </div>

  </base-layout>
</template>

 <!-- Define multiple choice format for branch choice and details-->
<style scoped>  
p {
  margin-top: 1.5em;
}

.choiceGroup {
  /*margin-left: 10%;*/
  padding: 1em;
}

.pause {
  height: 15px;
}

#recap_choice {
  margin-top: 40px;
}

#body_ex_bg {
  margin: 1px 1%;
  width: 98%;
  max-height: 300px;
}

.endChoice {
  margin-top: 2em;
  font-size: 15px;
}

.feelingSpan {
  margin-right: 5px;
}

.exampleSpan {
  margin-right: 10px;
}

ion-checkbox::part(container) {
  border-radius: 30%;
  border: 2px solid var(--ion-color-primary);
}

.checkItem {
  /* margin-left: 30%; */
  margin: auto 30%;
  font-size: 1.25em;
}

/* .transition {
  opacity: 0;
  transition: opacity 0.8s ease;
} */

@keyframes blink {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s linear infinite;
}

.bottom-input {
  width: 100%;
  text-align: right;
}

#messagesWrapper {
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 10px;
  box-sizing: border-box;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

ion-item {
  --border-width: 0px;
  --inner-border-width: 0px;
  border: none;
}

.chat-choice {
  width: 70%;
  height: 300%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}
.content {
  width: 80%;
}
.choice {
  width: 100%;
  text-align: center;
  margin-bottom: 8px;
  font-size: 1.2em;
  font-weight: bold;
}
.detail {
  width: 100%;
  text-align: center;
  white-space: normal; /* Allows the text to wrap */
  word-wrap: break-word; /* Ensures long words break correctly */
  line-height: 1.4em; /* Adjusts the spacing between lines */
}

.start-session-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 60vh;
  padding: 10px;
}

.center-btn-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}
</style>


<script setup>
//import $ from "jquery";
import {
  //useIonRouter,
  toastController,
  loadingController,
  IonItem,
  IonLabel,
  IonToggle,
  //IonTextarea,
  IonIcon,
  IonButton,
  IonList,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  //IonText,
  IonFooter,
  IonSelect, IonSelectOption,
  IonCheckbox
} from '@ionic/vue';
import {chevronBackCircle, chevronForwardCircle, micOutline} from 'ionicons/icons';
import ChatMessage from '@/components/ChatMessage.vue';
import ChatChoice from '@/components/ChatChoice.vue';
import ChatChoiceLong from '@/components/ChatChoiceLong.vue';
import ChatSubmit from '@/components/ChatSubmit.vue';
import ChatInput from '@/components/ChatInput.vue';
import ChatInputArea from '@/components/ChatInputArea.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';
import {store} from '@/store';
import {api} from '@/api';
import {ref, onMounted, nextTick, watch} from 'vue';
import {
  show_element_by_id, hide_element_by_id, delay, show_element_animated, scroll_to_bottom,
  loadAudio, toggleAudio, stopAudio, user_alias, gender, age, profession, nature, session, updateProfile,
  feeling_list, g_user_chat_history, blink_element, unblink_element, web_url, is_weixin,
  saveUserChatLocal, getUserChatLocal, g_ai_info, saveInfoLocal, getInfoLocal, deleteChatLocal, amount
} from '@/utils';
import { supabase } from "@/supabase";
const windowLanguage = window.language;


//const first_message = `你好，今天想说哪方面的困扰？我耐心倾听，充分了解你的情况。`;
const first_message = windowLanguage === 'zh'
  ? `你好，今天想说哪方面的困扰？我耐心倾听，充分了解你的情况。`
  : `Hi, what would you like to talk about today? I'm here to listen.`

const chat_messages = ref([first_message]);
const disableInput = ref(false);

var g_has_already_created_chat_history_record = false;

import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const chatpage_title = t('chatpage_title')

const debug = false;
const amount_per_chat = 99;
//const router = useIonRouter();
const user = store.user;
const isLoading = ref(true);
const new_user = ref(true);

const r_show_greeting = ref(true);
const r_show_chat_start = ref(false);
const r_show_charge_info = ref(false);
const r_show_shudong = ref(false);

const r_user_input = ref('');
const r_ai_message = ref(t('chat_ai_greeting'));
//const input_prompt = ref('使用语音输入法更方便哦');
const input_prompt = ref(
  windowLanguage === 'zh'
    ? '使用语音输入法更方便哦'
    : 'Using voice input can be easier'
)

const name_prompt = ref(
  windowLanguage === 'zh'
    ? '请输入你的名字...'
    : 'Type your name here...'
)

// const ai_detail_no = ref('困扰的问题说清楚啦，进入下一环节吧');
const ai_detail_no = windowLanguage === 'zh'
  ? ref('困扰的问题说清楚啦，进入下一环节吧')
  : ref('I’ve shared my issue—ready for the next step')
const AI_INPUT_MIN = 1;
const AI_INPUT_MAX = 3500;

// 2025 Jun Wang
//r_show_greeting.value = false;
//r_show_shudong.value = true;

let g_chat_id;
let g_saved_nature;
let jump_flag = 0;
let g_getting_profile = false;
let g_profile_loaded = false; // prevent re-running getProfile after first successful load

async function getProfile() {
  if (g_getting_profile) { console.log('getProfile: already running, skipping'); return; }
  g_getting_profile = true;
  // Reset UI state defensively in case Ionic keep-alive left stale state
  r_show_chat_start.value = false;
  r_show_charge_info.value = false;
  r_show_shudong.value = false;
  user_alias.value = '';
  gender.value = '';
  age.value = '';
  profession.value = '';
  nature.value = '';

  const loader = await loadingController.create({});
  const toast = await toastController.create({duration: 5000});
  await loader.present();
  try {
      // Wait for legacy session if we have a Supabase session but no legacy user yet
      if (!api.user() && session.value?.user?.id) {
          console.log('getProfile: Waiting for legacy bridge...');
          for (let i = 0; i < 5; i++) { // Wait up to 0.5 seconds
              await delay(0.1);
              if (api.user()) break;
          }
      }

      console.log('getProfile: checking legacy userInfo...');
      let data = await api.userInfo();

      // If legacy userInfo fails, check Supabase
      if (!data) {
        console.log('getProfile: No legacy session, checking Supabase session...');
        const { data: { session: sbSession } } = await supabase.auth.getSession();
        if (sbSession) {
          console.log('Found Supabase session in getProfile fallback');
          data = {
            ...sbSession.user,
            id: sbSession.user.id,
            uid: sbSession.user.id,
            horns_green: 0,
            horns_red: 0
          };
          // Only update session ref if it's currently null or empty
          if (!session.value?.user?.id) {
            session.value = { ...sbSession, user: data };
          }
          store.user = data;
        }
      } else {
        console.log('getProfile: Found legacy session data');
        // Only update session ref from legacy api if it has a user
        const legSession = api.session();
        if (legSession?.user?.id) {
          session.value = legSession;
        }
        store.user = data;
      }

      console.log("getProfile final data:", data?.id, "alias:", data?.user_alias);

    if (data) {
      console.log('getProfile', data);
      amount.value = data.horns_green + data.horns_red;
      if (sessionStorage.getItem('force_new_user') === 'true') {
        amount.value = 0; // Force 0 for testing flow
      }
      // console.log('horn amount', amount.value);
      if (data.gender) gender.value = data.gender;
      if (data.age) age.value = data.age;
      if (data.profession) profession.value = data.profession;
      nature.value = data.nature || '雨声';
      g_saved_nature = nature.value;
      
      // If user has an alias and it's not "none", it's not a new user
      if (data.user_alias && data.user_alias !== 'none') {
        user_alias.value = data.user_alias;
        new_user.value = false;
        resumeOrNewChat();
      } else {
        new_user.value = true;
        resumeOrNewChat();
        r_show_greeting.value = true;
      }
      g_profile_loaded = true;
    }
  } catch (error) {
    console.log('-- profile error --')
    toast.message = error.message;
    await toast.present();

    resumeOrNewChat(); // added 2025 JW

  } finally {
    //console.log('user alias', user_alias.value);
    isLoading.value = false;
    await loader.dismiss();
    g_getting_profile = false;
  }
}


async function start_chat_ai() {
  try {
    await saveUserChatHistory(true); // create a new chat history record (get a new g_chat_id), which deducts antlers
    r_show_greeting.value = false;
    show_element_animated(r_show_shudong);
  } catch (error) {
    const toast = await toastController.create({duration: 3000, position: 'top'});
    if (error.message.includes('鹿角不够') || error.message.includes('insufficient')) {
      r_show_shudong.value = false; // Hide shudong if it was shown/toggled
      r_show_greeting.value = true; // Re-show the greeting container reactively
      
      const updateSession = (data) => {
        if (data && session.value?.user) {
          // Object.assign on the session.value.user proxy ensures Vue triggers a re-render
          Object.assign(session.value.user, data);
          amount.value = (session.value.user.horns_green || 0) + (session.value.user.horns_red || 0);
        }
      };

      if (error.data) updateSession(error.data);

      const freshData = await api.userInfo(); // refresh balance and need_money from server
      if (freshData) updateSession(freshData);

      r_show_chat_start.value = false;
      r_show_charge_info.value = true;
      show_element_sequenced('div_charge_info');
    } else {
      r_show_greeting.value = true;
      toast.message = 'Failed to start chat: ' + error.message;
      await toast.present();
    }
  }
}

function process_alias() {
  let input = user_alias.value;
  input = input.replace(/(.+)吧$/, '$1');
  input = input.replace(/.+我/, '');
  input = input.replace(/我?.*[叫是]/, '');
  //console.log('processed alias', input)
  if (input.length) user_alias.value = input;
}

async function submit_my_username() {
  //console.log('submit_my_username',user_alias.value, user.id);
  process_alias(); // in case user input is sth like 我叫xx, 我的昵称是xx, 叫我xx吧

  updateProfile({user_alias: user_alias.value});
  await delay(1);

  new_user.value = false;
  r_show_charge_info.value = false;
  r_show_chat_start.value = true;
  show_element_sequenced('div_chat_start');
}

function chat_greeting() {
  hide_element_by_id('div_first_time');
  
  // If we are already showing charge info, check if they now have enough money before proceeding to chat start
  if (r_show_charge_info.value) {
    if (amount.value >= amount_per_chat) {
      r_show_charge_info.value = false;
      r_show_chat_start.value = true;
      show_element_sequenced('div_chat_start');
    } else {
      // Still not enough money, keep showing charge info
      // Optional: you could add a toast here saying "Still insufficient Antlers"
      return;
    }
    return;
  }

  // 2025 Jun Wang
  if (amount.value >= amount_per_chat) { // enough amount
    r_show_chat_start.value = true;
  } else if (!new_user.value) { 
    // If old user with no money, show charge info. 
    r_show_charge_info.value = true;
    r_show_chat_start.value = false;
  }
  r_show_greeting.value = true;
  show_element_sequenced('div_greeting');
}


/*async function post_request(options = {}) {
  return api.ai_req(g_chat_id, options);
}*/
async function post_request(options = {}) {
  //return api.ai_req(g_chat_id, options);

  //let server_url = 'TODO: https://api.langev.com/[changjinglu]/';
  // let server_url = 'https://api2.langev.com/changjinglu/';
  //let server_url = 'http://localhost:9111';
  const server_url = process.env.VUE_APP_API_BASE || '/api/';

  if (options && !options.uid) {
    //console.log('post', user)
    options.uid = user.id; // '00d9ac26-7700-4510-b7d9-20e53c872b66'; // for debug
  }

  const response = await fetch(server_url, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(options),
  });
  let error = null;
  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    error = new Error(message);
  }
  const data = await response.json();
  return {data, error};
}


function show_more_details() {   // 显示树洞环节
  r_ai_message.value = first_message;
  r_user_input.value = '';

//  show_element_animated(r_show_shudong);
}



async function getLastChatElement() {
  await nextTick(); // wait for DOM to update
  const messages = document.querySelectorAll('.chat-message');
  return messages[messages.length - 1];
}


const allButtonsDisabled = ref(false);
const visibleButtons = ref([]);

function showChoicesFromAI(choices) {
  visibleButtons.value = []; // Reset visible buttons
  choices.forEach((_, index) => {
    setTimeout(() => {
      visibleButtons.value.push(index); // Add the next button after the delay
    }, index * 500); // 0.5-second delay per button
  });
}



async function submit_user_input(last_input_mode='text') {
  console.log('======= chat_messages 1:', chat_messages.value);
  if (!chat_messages.value) {
    chat_messages.value = [first_message];
  }
  let last_message = chat_messages.value.at(-1).title;
  let input = r_user_input.value.trim();
  console.log('---- user shudong input:', input)
  console.log('---- last_message:', last_message)
  if (chat_messages.value.length==1 && [...input].filter(c => c >= '\u4e00' && c <= '\u9fff').length > [...input].filter(c => /[A-Za-z]/.test(c)).length){
      ai_detail_no.value='困扰的问题说清楚啦，进入下一环节吧' //switch to Chinese version if the 1st user input is in Chinese
    }
  if (last_message=='体会一下，情绪感受有没有引发你身体上不舒服的感觉？比如：胸闷，喉咙卡，肩膀紧绷，头痛什么的...'){
    console.log('---- last_message:', last_message)
    if (input=='对，有的'){
      ai_detail_no.value='“身体感觉”描述完了'
    }
    if (input=='现在没有'){
      ai_detail_no.value='结束“画面”练习，讨论需要'
    }    
  }
  if (last_message=='Take a moment to notice—does this feeling bring up any physical discomfort in your body?\nIt could be chest tightness, a lump in the throat, tense shoulders, a headache, or any other physical sensations you notice.'){
    console.log('---- last_message:', last_message)
    if (input=='Yes'){
      ai_detail_no.value='Done with body sensations.'
    }
    if (input=='Not right now'){
      ai_detail_no.value='End the imagery exercise and discuss needs.'
    }    
  }
  if (last_message && last_message.includes('你会看到一个画面慢慢呈现出来。停留一会儿，然后用语言描述这个画面。')) {
    console.log('---- last_message:', last_message)
    if (input=='暂时没有'){
      ai_detail_no.value='我的“需要”都讨论完了'
    }
  }
  if (last_message && last_message.includes('An image may slowly come into view. Take a moment to sit with it')) {
    console.log('---- last_message:', last_message)
    if (input=='Not at the moment.'){
      ai_detail_no.value='I’m done with all my needs.'
    }  
  }
  if (last_message && last_message.includes('你愿不愿意尝试换位思考')) {
    console.log('---- last_message:', last_message)
    if (input=='我愿意'){
      ai_detail_no.value='结束“换位思考”练习'
    }  
  }
  if (last_message && last_message.includes('shoes and explore what feelings and needs')) {
    console.log('---- last_message:', last_message)
    if (input=='I’m willing.'){
      ai_detail_no.value='End the perspective-taking exercise.'
    }  
  }
  if (last_message && last_message.includes('没有找到适合讨论的想法')) {
    console.log('---- last_message:', last_message)
    if (input=='那就换一种讨论的方向'){
      ai_detail_no.value='结束谈话'
    }
  }
  if (last_message && last_message.includes('No suitable thoughts to discuss.')) {
    console.log('---- last_message:', last_message)
    if (input=='Let’s take a different approach.'){
      ai_detail_no.value='End the conversation.'
    }
  }
  if (last_message && last_message.includes('情绪背后，往往有一些未必可靠的想法或信念，导致我们陷入情绪漩涡和思维误区')) {
    console.log('---- last_message:', last_message)
    if (input=='我不想探索'){
      ai_detail_no.value='结束谈话'
    }
  }
  if (last_message && last_message.includes('Behind our feelings, there are often thoughts or beliefs that may not be entirely reliable,')) {
    console.log('----FLAG last_message:', last_message)
    console.log('----FLAG input:', input, '==', 'I don’t want to explore.')
    if (input=='I don’t want to explore.'){
      ai_detail_no.value='End the conversation.'
      console.log('---- Flag change to:', 'End the conversation.')
    }
  }
  if (input.length == 0 || input.length > AI_INPUT_MAX) {
    console.log('user input too short or too long, so do nothing')
    return
  }

  if (!g_user_chat_history.user_input) g_user_chat_history.user_input = '';
  g_user_chat_history.user_input += (g_user_chat_history.user_input ? '|' : '') + input;
  g_user_chat_history.details_input = g_user_chat_history.user_input; // Ensure details_input is synced for server validation
  saveUserChatLocal();

  chat_messages.value.push(input);  // add user chat message to show on screen
  if ((!g_user_chat_history.multi_turn_chat_seq || g_user_chat_history.multi_turn_chat_seq.length === 0) && window.language === 'en') {
      input = `[SYS_LANGUAGE:en] ` + input;
  }
  disableInput.value = true;
  r_user_input.value = ''; // reset input box
  scroll_to_bottom();


  // generate a response message
  let count = chat_messages.value.length;
  let duration = 0.5;

  input_prompt.value = "";

  if (last_input_mode == 'click_choice_from_AI') {
    await delay(2); // let user have time to get used to blinking
  }

  chat_messages.value.push(">..."); // once add a msg to chat_messages, the page will start to display the msg

  let lastChat = await getLastChatElement();
  blink_element(lastChat);
  let response = await send_to_backend_AI(input);
  unblink_element(lastChat);

  if (!response) {
    // API failed (timeout, network error, empty response, etc.)
    console.error('AI response was null or failed.');
    chat_messages.value.pop(); // Remove the "..." loading placeholder
    disableInput.value = false; // Re-enable input so user is not stuck
    const t = await toastController.create({
      message: 'AI service not responding, please retry',
      duration: 3000,
      position: 'top',
      color: 'danger'
    });
    await t.present();
    return; // Abort further processing
  }

  try {
    // a list of choices for user to select
    response = JSON.parse(response);
    console.log(response);
    allButtonsDisabled.value = false;
    disableInput.value = true;
  } catch (error) {
    // normal text or string
    console.log('- normal api response text:', response);
    disableInput.value = false;
    allButtonsDisabled.value = true;
  }

  if (response) {
    chat_messages.value[chat_messages.value.length - 1] = response;
    if (isDictionary(response)) {
      //if (response.type=='meditation'){ }
      if (response.type=='list'){
        chat_messages.value[chat_messages.value.length - 1]['choicesVisible'] = true;
        chat_messages.value[chat_messages.value.length - 1]['isInitialTitle'] = true;
        showChoicesFromAI(response.choices);
      }
    }

    g_user_chat_history.chat_messages = chat_messages.value;
    saveUserChatLocal();
    await saveUserChatHistory();

  }
  //disableInput.value = false;
  scroll_to_bottom();
}


async function ai_more_details(end = 0) {
  console.log('======= chat_messages 2:', chat_messages.value);
  let input = r_user_input.value.trim();
  if (end) input = ai_detail_no.value;//no_more_detail;
  console.log('======= chat_messages 3',input);

  chat_messages.value.push(input);  // add user chat message to show on screen
  disableInput.value = true;
  r_user_input.value = ''; // reset input box
  scroll_to_bottom();
  console.log('======= chat_messages 3.1',input);
  // generate a response message
  let count = chat_messages.value.length;
  let duration = 0.5;
  if (end) {
    jump_flag++;
    if (ai_detail_no.value=='困扰的问题说清楚啦，进入下一环节吧') {
      ai_detail_no.value='这个感受说完了';
    }
    if (ai_detail_no.value=='I’ve shared my issue—ready for the next step') {
      ai_detail_no.value='I’m done talking about this feeling.';
    }
    if (ai_detail_no.value=='结束谈话') {
      deleteChatLocal();
      newChat();
    }
    if (ai_detail_no.value=='End the conversation.') {
      deleteChatLocal();
      newChat();
    }
    if (ai_detail_no.value=='行动计划已经清楚了') {
      ai_detail_no.value='结束谈话';
    }
    if (ai_detail_no.value=='Action plan is clear.') {
      ai_detail_no.value='End the conversation.';
    }
    if (ai_detail_no.value=='已经讨论了目标') {
      ai_detail_no.value='行动计划已经清楚了';
    }
    if (ai_detail_no.value=='Goals discussed.') {
      ai_detail_no.value='Action plan is clear.';
    }
    if (ai_detail_no.value=='新想法找好了') {
      ai_detail_no.value='已经讨论了目标';
    }
    if (ai_detail_no.value=='New thoughts found.') {
      ai_detail_no.value='Goals discussed.';
    }
    if (ai_detail_no.value=='想法找好了，进入下一个环节') {
      ai_detail_no.value='新想法找好了';
    }
    if (ai_detail_no.value=='Thoughts set. Next.') {
      ai_detail_no.value='New thoughts found.';
    }
    if (ai_detail_no.value=='我的“需要”都讨论完了') {
      ai_detail_no.value='想法找好了，进入下一个环节';
    }
    if (ai_detail_no.value=='I’m done with all my needs.') {
      ai_detail_no.value='Thoughts set. Next.';
    }
    if (ai_detail_no.value=='结束“换位思考”练习') {
      ai_detail_no.value='想法找好了，进入下一个环节';
    }
    if (ai_detail_no.value=='End the perspective-taking exercise.') {
      ai_detail_no.value='Thoughts set. Next.';
    }
    if (ai_detail_no.value=='结束“画面”练习，讨论需要') {
      ai_detail_no.value='我的“需要”都讨论完了';
    }
    if (ai_detail_no.value=='End the imagery exercise and discuss needs.') {
      ai_detail_no.value='I’m done with all my needs.';
    }
    if (ai_detail_no.value=='结束“身体的感觉”环节') {
      ai_detail_no.value='我的“需要”都讨论完了';
    }    
    // if (ai_detail_no.value=='End the body sensations section.') {
    //   ai_detail_no.value='I’m done with all my needs.';
    // }    
    if (ai_detail_no.value=='Done with body sensations.') {
      ai_detail_no.value='End the imagery exercise and discuss needs.';
    } 
   } //改
console.log('======= chat_messages 3.2', ai_detail_no.value);
console.log('======= chat_messages 3.3',jump_flag);
   // either a simple response or use ai_summarize
  input_prompt.value = "";
  chat_messages.value.push(">...");
  console.log('======= chat_messages 3',input);
  if (input.length >= 1 && input.length <= AI_INPUT_MAX) {
      let lastChat = await getLastChatElement();
      console.log('======= chat_messages 4',input);
      blink_element(lastChat);
      let response = await send_to_backend_AI(input);
      unblink_element(lastChat);

      if (!response) {
        // API failed (timeout, network error, empty response, etc.)
        console.error('AI response was null or failed.');
        chat_messages.value.pop(); // Remove the "..." loading placeholder
        disableInput.value = false; // Re-enable input so user is not stuck
        const t = await toastController.create({
          message: 'AI server failed to respond, please try again',
          duration: 3000,
          position: 'top',
          color: 'danger'
        });
        await t.present();
        return; // Abort further processing
      }
            
      try {
        // a list of choices for user to select
        response = JSON.parse(response);
        console.log(response);
        allButtonsDisabled.value = false;
        disableInput.value = true;
      } 
      catch (error) {
        // normal text or string
        console.log('- normal api response text:', response);
        disableInput.value = false;
        allButtonsDisabled.value = true;
      }
      if (response) {
        chat_messages.value[chat_messages.value.length - 1] = response;
        if (isDictionary(response)) {
          if (response.type=='meditation'){
            disableInput.value = false;
            ai_detail_no.value='结束“身体的感觉”环节';
          }
          if (response.type=='list'){
            chat_messages.value[chat_messages.value.length - 1]['choicesVisible'] = true;
            chat_messages.value[chat_messages.value.length - 1]['isInitialTitle'] = true;
            showChoicesFromAI(response.choices);
          }
        }
        g_user_chat_history.chat_messages = chat_messages.value;
        saveUserChatLocal();
        await saveUserChatHistory();
      }
      //disableInput.value = false;
      scroll_to_bottom();
   }
}



async function userSelectChoiceFromAI(choice, choice_index, chat_message_index) {
  chat_messages.value[chat_message_index]['choicesVisible'] = false;
  chat_messages.value[chat_message_index]['isInitialTitle'] = true;

  console.log("You selected:", choice);
  allButtonsDisabled.value = true; // Disable all buttons
  r_user_input.value = choice;
  submit_user_input('click_choice_from_AI')
}

function isDictionary(value) {
  return value instanceof Object && value.constructor === Object;
}


function save_user_input(input) {
  if (!g_user_chat_history.user_input) {
    g_user_chat_history.user_input = '';
  }

  g_user_chat_history.user_input += input;
  //saveUserChatLocal(); // 2025 JW; save g_user_chat_history to localStorage
}



async function show_element_sequenced(div_name) {
  await nextTick();
  await delay(0.5);
  let div = document.getElementById(div_name);
  if (!div) return;
  let elements = div.getElementsByClassName('hidden');
  while (elements.length) {
    elements[0].classList.remove('hidden');
    elements = div.getElementsByClassName('hidden');
    await delay(debug ? 0.2 : 0.9);
    scroll_to_bottom();
  }
}





Array.prototype.random = function () {
  return this[Math.floor((Math.random() * this.length))];
}



async function send_to_backend_AI(curr_input) {
  console.log('send to backend AI:', curr_input)

  console.log('... g_user_chat_history.user_input:', g_user_chat_history.user_input);
  g_user_chat_history.user_input = g_user_chat_history.user_input.replace(/^undefined\|/, '');

  try {
    if (!g_user_chat_history.multi_turn_chat_seq) {
      // multi_turn_chat_seq is empty
      let user_input = g_user_chat_history.user_input;
      g_user_chat_history.multi_turn_chat_seq = [user_input];
    } else {
      g_user_chat_history.multi_turn_chat_seq.push(curr_input);
    }

    console.log('... g_user_chat_history:', g_user_chat_history);
    if (!g_chat_id) {
      console.log('g_chat_id is not defined');
      throw new Error('g_chat_id is not defined');
    }

    let options = {
      task: 'gpt_shudong', 
      subtask: 'input_1',
      user_input: curr_input, 
      g_chat_id: g_chat_id.toString()    
    };
    console.log('options', options);

    let {data, error} = await post_request(options);

    console.log('api request result:', data);

    let gpt_response_text = data.gpt_shudong;

    if (gpt_response_text.includes("心理咨询") && gpt_response_text.length<20) {
      gpt_response_text = "我会用我的心理学能力尽力帮助你，你也可以另外寻求专业心理咨询师的帮助"
    }
    gpt_response_text = gpt_response_text.replace(/<<<|>>>/g, '');
    //console.log('GPT response:', gpt_response_text)

    if (error || !data) return null;

    g_user_chat_history.multi_turn_chat_seq.push(gpt_response_text);
    saveUserChatLocal();

    return gpt_response_text;

  } catch (error) {
    console.log(error.message);
    return null;
  }
}



async function saveUserChatHistory(insert_new = false, ended = false) {
  try {
    //await loader.present();

    if (insert_new && !g_has_already_created_chat_history_record) {
      console.log('Attempting to create a new chat history record with history:', g_user_chat_history);
      let data = await api.userTrackInsert(g_user_chat_history);
      console.log('userTrackInsert response: ', data);
      
      if (!data) {
        console.warn('userTrackInsert returned null or undefined');
        return;
      }
      
      if (data?.code < 0) {
        console.error('userTrackInsert error:', data.code, data.msg);
        const err = new Error(data.msg || 'Failed to create chat history');
        err.data = data; // Attach the response data so calling code can access need_money, etc.
        throw err;
      }

      if (data.id) {
        g_chat_id = data.id;
        g_ai_info.chat_id = g_chat_id;
        saveInfoLocal();
        console.log('Successfully set g_chat_id:', g_chat_id);
        g_has_already_created_chat_history_record = true;
      } else {
        console.warn('userTrackInsert response missing id property');
        throw new Error('Chat ID missing from response');
      }
    } else {
        let ended_at = ended ? new Date().getTime() : null;
        console.log('ended at:', ended_at)
        let error = await api.userTrackUpdate(g_chat_id, g_user_chat_history, ended_at);
        if (error.code) throw new Error(error.msg);
    }
  } catch (error) {
    console.log(error.message)
    throw error; // Propagate error upstream for UI handling
  } finally {
    //await loader.dismiss();
  }
}

function newChat() {
  if (is_weixin.value) {
    window.location.replace(web_url.value);
  } else {
    window.location.reload();
  }
}

// TODO 2025 Jun Wang
async function resumeOrNewChat() {
  console.log(' >>>>>>>>>>>>>> resume or new chat');

  getUserChatLocal(); // g_user_chat_history
  getInfoLocal(); // g_ai_info

  g_chat_id = g_ai_info.chat_id;
  console.log(' >>>>>>>>------- g_user_chat_history:', g_user_chat_history);
  console.log('                 g_chat_id:', g_chat_id);

  //let input = g_user_chat_history.user_input;
  //if (!input || !g_chat_id) { // this is a new chat
  //if (!g_chat_id) { // this is a new chat
  if (!g_chat_id || g_chat_id) { // force into a new chat
    console.log(' >>>>>>>>------- new chat');
    g_user_chat_history.user_input = '';
    g_user_chat_history.details_input = '';
    g_user_chat_history.chat_messages = [];
    g_user_chat_history.multi_turn_chat_seq = [];
    if (!new_user.value) chat_greeting(); // skip for new users: they need alias prompt, not chat_greeting

    g_has_already_created_chat_history_record = false;
    // saveUserChatHistory(true); // removed 2026 JW; moved to start_chat_ai
    saveUserChatLocal();
    chat_messages.value = [first_message];

  } else {
    // 2025 Jun Wang
    chat_messages.value = g_user_chat_history.chat_messages;
    console.log(' >>>>>>>>------ resume chat:', chat_messages.value,  'g_chat_id:', g_chat_id);

    r_show_greeting.value = false;
    /*if (!g_user_chat_history.user_input.includes('|') && !g_user_chat_history.next) { // missing more details
      console.log('- JW: show_more_details()')
      show_more_details();
    } 
    */
  }
}

onMounted(async () => {
  console.log('******************************** onMounted\n\n');
  
  if (session.value?.user?.id) {
    await getProfile();
  }

  // Watch for session to become available (handles async sync delay)
  watch(() => session.value?.user?.id, async (newId) => {
    if (newId && !g_profile_loaded) {
       console.log('Session ID detected in watch, getting profile...');
       await getProfile();
    }
  });

  // Also watch store.user for legacy bridge completion
  watch(() => store.user?.id, async (newId) => {
    if (newId && !g_profile_loaded) {
      console.log('Store User ID detected in watch, getting profile...');
      await getProfile();
    }
  });

  console.log('******************************** after onMounted setup\n\n');

  window.onbeforeunload = function () { //  event that triggers before the user closes or refreshes the page.
    console.log('******************************** onbeforeunload\n\n');
    //deleteChatLocal(); // 2025 JW

    /*
    // in case user exits before hitting submission button, save input on screen if any
    let input = r_user_input.value.trim();
    if (input) save_user_input(input);
    saveUserChatLocal();
    */
  }
});
</script>
